export default "__VITE_ASSET__B$UQyE7a__"